<div>
    <mat-tab-group #tabGroup mat-stretch-tabs="false">
        <mat-tab label="Controller Software">
            <div class="flex-center">
                <div class="row softwarereleasetofield">
                    <div class="edituser col-md-3 col-sm-12">
                        <mandatory-version-levels (onLevelSelectedTrigger)="onNewLevelSelected($event)">
                        </mandatory-version-levels>
                    </div>
                    <div class="softwarereleases col-md-9 col-sm-12">
                        <mandatory-version-list [familyCodes]="familyCodes"
                                                [softwareReleases]="softwareReleases"></mandatory-version-list>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Peripheral Software">
            <div class="flex-center">
                <div class="row softwarereleasetofield">
                    <div class="edituser col-md-3 col-sm-12">
                        <mandatory-version-peripheral-compatibility-groups (controllerGroupSelectedTrigger)="onNewGroupSelected($event)"></mandatory-version-peripheral-compatibility-groups>
                    </div>
                    <div class="softwarereleases col-md-9 col-sm-12">
                        <mandatory-version-peripheral-list></mandatory-version-peripheral-list>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>